namespace nscs.scene {

    import BaseScreen = nscs.screen.BaseScreen;

    export class MainScene extends Phaser.Scene {

        public static instance:MainScene = null;

        public inputController:nscs.input.InputController;
        public factory:nscs.gameplay.Factory;
        public gameplay:nscs.gameplay.Gameplay;

        private currentScreensContainer:Phaser.GameObjects.Container;
        private currentScreen:BaseScreen;
        private soundControl_mc:Phaser.GameObjects.Image;
        private logo_btn:Phaser.GameObjects.Image;

        public create():void {
            MainScene.instance = this;

            this.inputController = new nscs.input.InputController(this);
            this.factory = new nscs.gameplay.Factory(this);

            this.currentScreensContainer = new Phaser.GameObjects.Container(this, 0, 0);
            this.children.add(this.currentScreensContainer);

            this.logo_btn = new Phaser.GameObjects.Image(this, 0, 290, 'ui-atlas', 'logo_btn'+'0000').setOrigin(0, 0);
            this.logo_btn.setInteractive({cursor: 'pointer'});
            this.logo_btn.on('pointerup', () => {
                window.open("http://www.mccruelty.com",'_blank');
                this.logo_btn.setFrame('logo_btn'+'0000');

                sendEvent(petaGA_GameCategory_Game, 'Click', 'New Super Chick Sisters - McCruelty Link Click');
            });
            this.logo_btn.on('pointerout', () => {
                this.logo_btn.setFrame('logo_btn'+'0000');
            });
            this.logo_btn.on('pointerover', () => {
                this.logo_btn.setFrame('logo_btn'+'0001');
            });

            this.soundControl_mc = new Phaser.GameObjects.Image(this, 464, 306, 'ui-atlas', 'soundControl_mc' + '0000');
            this.soundControl_mc.setInteractive({cursor: 'pointer'});
            this.soundControl_mc.on('pointerup', () => {
                nscs.sound.SoundManager.getInstance().mute();
                this.soundControl_mc.setFrame(nscs.sound.SoundManager.getInstance().muted ? 'soundControl_mc' + '0009' : 'soundControl_mc' + '0000');

                if (nscs.sound.SoundManager.getInstance().muted) {
                    sendEvent(petaGA_GameCategory_Game, 'Audio Off', 'New Super Chick Sisters - Audio Off');
                } else {
                    sendEvent(petaGA_GameCategory_Game, 'Audio On', 'New Super Chick Sisters - Audio On');
                }
            });

            this.switchScreen(new screen.SelectLanguageScreen(this));

            this.children.add(this.soundControl_mc);
            this.children.add(this.logo_btn);

            this.updateLogoAndSndBtnVisibility();

            this.logo_btn.setScrollFactor(0);
            this.soundControl_mc.setScrollFactor(0);

            //worlds direct testing
            // this.gameplay = new nscs.gameplay.Gameplay();
            // this.startLevel('1');
        }

        public resetGameplay():void {
            if (this.gameplay) {
                this.gameplay.destroy();
            }
            this.setWorldsNumber(1);
            this.gameplay = new nscs.gameplay.Gameplay();
        }

        public playAsPam():void {
            this.resetGameplay();
            this.gameplay.character = 'pam';
            this.startGame();
        }

        private subWorld:string = null;
        public setWorldsNumber(worldNumber, subWorld:string = null):void {
            this.worldNumber = worldNumber;
            this.subWorld = subWorld;
        }

        public getWorldNumber():number {
            return this.worldNumber;
        }

        private worldNumber:number = 1;
        public playGame():void {
            this.showStorySlides(()=>{
                this.startGame();
            });
        }

        public startLevel(worldId: number | string):void {
            this.setWorldsNumber(Math.floor(Number(worldId)));
            this.gameplay.loadWorld(worldId,true, true);
            this.gameplay.gameScreen.showNewGameNewWorldScreen();

            nscs.sound.SoundManager.getInstance().playMusic('soundtrack' + this.worldNumber, true);
        }

        public startGame():void {
            this.startLevel(this.subWorld!=null ? this.subWorld : String(this.worldNumber));
        }

        public showStorySlides(onComplete):void {
            this.gameplay.destroyPreviousWorlds();
            this.switchScreen(new nscs.screen.StorySlides(this, this.worldNumber, ()=>{
                if (this.worldNumber == 3) {
                    this.switchScreen(new nscs.screen.BonusVideoScreen(this, onComplete));
                } else {
                    onComplete();
                }
            }), false, true);
        }

        public proceedLevelComplete():void {
            sendEvent(petaGA_GameCategory_Game, 'Win', 'New Super Chick Sisters - Win World ' + this.worldNumber);

            this.setWorldsNumber(this.gameplay.getNextWorldNumber());
            if (this.worldNumber == 6) {
                // END OF GAME
                this.showStorySlides(()=>{
                    this.switchScreen(new nscs.screen.MainMenuScreen(this)/*new nscs.screen.HigscoreScreen(this)*/);
                });
            } else {
                this.playGame();
            }
        }

        public update():void {
            let screens = this.currentScreensContainer.getAll();
            for (let c of screens) {
                if (c instanceof nscs.screen.BaseScreen && this.currentScreen != c) (c as nscs.screen.BaseScreen).updateScreen();
            }
            this.currentScreen.updateScreen();
        }

        private updateLogoAndSndBtnVisibility():void {
            this.logo_btn.visible = (
                this.currentScreen instanceof nscs.screen.MainMenuScreen
                ||
                this.currentScreen instanceof nscs.screen.InGameUI
                ||
                this.currentScreen instanceof nscs.screen.GameScreen
            );
            this.logo_btn.alpha = this.currentScreen instanceof nscs.screen.GameScreen ? 0.6 : 1;
            this.soundControl_mc.visible = !(
                this.currentScreen instanceof nscs.screen.SelectLanguageScreen
            );
        }

        public switchScreen(newScreen:BaseScreen, useTransition:boolean = false, destroyOld:boolean = true, onMidCallback = null):void {
            if (this.currentScreen) {
                let prevScreen = this.currentScreen;
                this.currentScreen = newScreen;
                prevScreen.switchScreen(newScreen, useTransition, destroyOld, ()=>{
                    if (onMidCallback) onMidCallback();
                    this.updateLogoAndSndBtnVisibility();
                });
            } else {
                this.currentScreensContainer.add(newScreen);
                this.currentScreen = newScreen;
                this.updateLogoAndSndBtnVisibility();
            }
        }
    }
}
